import React from 'react'
import ResumeUI from '../../components/core-ui/resume/resume-ui'

const ResumePage = () => <ResumeUI />

export default ResumePage
